import { isNumber } from "lodash";
import { calculateCalibratedPrediction } from "./genericHelpers";
import * as constants from "./constants";
/* This function returns the Calibrated Prediction column that will be rendered for each database.
  scores is an array of numbers and null, e.g. [null, null, 0.00034, 1.3345, 0] 
  Function sorts scores from higher to lower and takes the first one to calculate the Calibrated Prediction.
  We remove the null scores since we don't need them to calculate the Calibrated Prediction.
*/
export const getCalibratedPrediction = (databaseThresholds, scores) => {
  if (
    !scores?.length ||
    (Array.isArray(scores) &&
      !scores.every((elem) => {
        return (
          typeof elem === "number" ||
          typeof elem === "string" ||
          elem === 0 ||
          elem === null
        );
      }))
  ) {
    return constants.unknown;
  }

  let scoresArray = scores?.filter((s) => s !== null);

  const inverted = databaseThresholds?.isInverted;
  if (inverted) {
    scoresArray = scoresArray.map((score) => {
      if (score === 0) return 0;
      return -1 * score;
    });
  }

  scoresArray.sort((a, b) => {
    return b - a;
  });

  const finalScore = scoresArray[0];

  if (
    !databaseThresholds ||
    Object.keys(databaseThresholds || {}).length === 0 ||
    (!finalScore && !isNumber(finalScore))
  ) {
    return constants.unknown;
  }

  return calculateCalibratedPrediction(finalScore, databaseThresholds);
};
